import React from 'react';
import {connect} from 'react-redux'
import { stopSubmit } from 'redux-form'
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import * as colors from 'material-ui/styles/colors';


import PageBase from '../../../components/PageBase';

import gStyles from '../../../styles'

import PasswordForm from './PasswordForm'

import * as actions from '../../../actions'

const MASTER_TYPE = "password"

const validate = values => {
  const errors = {}
  const requiredFields = [
    "password",
    "passwordConfirm",
    "oldPassword",
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })

  if (values.password && !/^(?=.*\d)(?=.*[a-z])\w{8,24}$/.test(values.password)) {
    errors.password = '英数混在8〜24文字にして下さい。'
  }

  if (values.oldPassword && !/^(?=.*\d)(?=.*[a-z])\w{8,24}$/.test(values.oldPassword)) {
    errors.oldPassword = '英数混在8〜24文字にして下さい。'
  }

  if (values.password && values.oldPassword) {
    if (values.password == values.oldPassword) {
      errors.password = 'パスワードを変更して下さい。'
    }
  }

  if (values.password && values.passwordConfirm) {
    if (values.password != values.passwordConfirm) {
      errors.passwordConfirm = '確認パスワードが一致しません。'
    }
  }

  return errors
}

class PasswordPage extends React.Component {

  componentDidMount() {
  }

  render() {

    const {
      handleFormRegistClick,
    } = this.props

    const form = this.props.form || {}

    return (

      <PageBase title="パスワード更新" >

        <div>

          <div style={gStyles.searchBoxContainer}>

            <Paper style={{...gStyles.contentsPaper}}>
              <PasswordForm 
                onFormRegistClick={handleFormRegistClick} 
                initialValues={form}
              />
            </Paper>

          </div>

        </div>

      </PageBase>

    )
  }

}

const mapStateToProps = (state) => ({
  form: state.master.form[MASTER_TYPE],
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : () => {dispatch(actions.systemMasterInit(MASTER_TYPE))},
  handleFormRegistClick : (values) => {
    const errors = validate(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }
    dispatch(actions.userMasterFormRegist(MASTER_TYPE, null, values, null, null))
  },
})

PasswordPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(PasswordPage)

export default PasswordPage;



// WEBPACK FOOTER //
// ./src/containers/master/password/PasswordPage.js